import script from "./mber-pswd-chng.vue?vue&type=script&setup=true&lang=js"
export * from "./mber-pswd-chng.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__